<template>
    <header class="kleptos-header">

        <!-- BLUE ENERGY -->
        <KleptOSMenubarEnergy
            v-if="theme == 'theme-os'"
            energy-type="blue"
        />

        <!-- SYSTEM MENU -->
        <div class="kleptos-header-menu">

            <!-- MENU -->
            <button
                class="kleptos-header-menu-btn"
                :class="{ active: isActive('sysMenu') }"
                @click="openFile('/Desktop/My Computer/Drive/System/Menu')"
            >
                Menu
            </button>

            <!-- TASKS -->
            <button
                class="kleptos-header-menu-btn"
                :class="{ active: isActive('sysInfo') }"
                @click="openFile('/Desktop/My Computer/Drive/System/Info')"
            >
                Tasks
            </button>

            <!-- USER -->
            <button
                class="kleptos-header-menu-btn"
                :class="{ active: isActive('sysUser') }"
                @click="openFile('/Desktop/My Computer/Drive/System/User')"
            >
                User
            </button>

            <!-- AWAY -->
            <button
                title="[esc]"
                class="kleptos-header-menu-btn"
                @click="showSystem(false)">
                Away
            </button>

        </div>

        <!-- RED ENERGY -->
        <KleptOSMenubarEnergy
            v-if="theme == 'theme-os'"
            energy-type="red"
        />

    </header>
</template>

<script>
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';
    import MenubarEnergy from './MenubarEnergy';

    export default {
        components: {
            KleptOSMenubarEnergy: MenubarEnergy,
        },
        props: {
            theme: {
                type: String,
                required: true
            },
        },
        computed: {
            ...mapGetters('gameOS', {
                windows: 'getWindows'
            }),
        },
        methods: {
            ...mapActions('gameOS', [
                'openWindow', // replace
                'openFile',
                'showSystem'
            ]),
            isActive(label) {
                // return this.windows.find(panel => panel.label === label);
            }
        }
    }
</script>

<style lang="scss" scoped>

    $kleptos-header-height: 36px;

    .kleptos-header {
        display: flex;
        position: absolute;
        top: 0;
        width: 100%;
        background: red; //danger!
    }

    .theme-95 .kleptos-header {
        height: rem-calc(40); //44px;
        background: rgba(black, 0.15);
    }

    .theme-os .kleptos-header {
        height: 36px;
        background: linear-gradient(to bottom, rgba(#333333,1) 0%,rgba(#090909,1) 100%);
    }

    .kleptos-header-menu {
        display: flex;
        align-items: center;
        position: absolute; // so menu items not affected by components either side
        left: 50%;
        height: 100%;
        transform: translateX(-50%);
    }

    .kleptos-header-menu-btn {
        display: flex;
        height: 100%;
        align-items: center; // ie edge
        padding: rem-calc(0 15);
        border: 0;
        background: none;
        font-size: rem-calc(15); // [LOCKED]
        color: rgba(white, 0.5);
        text-transform: uppercase;
        transition: background 100ms linear;

        &.active {
            color: white;
        }

        &:active {
            background: rgba(black, 0.1) !important;
        }

        &:hover {
            background: rgba(black, 0.1);
        }
    }
</style>